// Readable fallback for a snake_case key that has no translation yet.
export const humanizeKey = (key: string): string => key.replace(/_/g, ' ').replace(/^./, (char) => char.toUpperCase())

export const areArraysEqual = <T = string>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) {
    return false
  }

  const sortedA = [...a].sort()
  const sortedB = [...b].sort()

  for (let i = 0; i < sortedA.length; i += 1) {
    if (sortedA[i] !== sortedB[i]) {
      return false
    }
  }

  return true
}

export const DOWNLOAD_ANCHOR_TTL_MS = 60_000

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  window.setTimeout(() => {
    link.remove()
    URL.revokeObjectURL(url)
  }, DOWNLOAD_ANCHOR_TTL_MS)
}

export const downloadUrl = (url: string): void => {
  const link = document.createElement('a')
  link.href = url
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const calculateBoundedPercentage = (numerator: number, total: number): number => {
  if (!total || numerator === 0) return 0
  if (numerator === total) return 100

  const percentage = Math.round((numerator / total) * 100)
  return Math.max(1, Math.min(99, percentage))
}
